import approx from 'approximate-number';
import PropTypes from 'prop-types';
import Rating from '@mui/material/Rating';
import React, { Fragment } from 'react';
import { Row } from 'components/Grid';

const noop = () => null;
const styles = {
  bottomMargin: {
    marginBottom: 10,
  },
  label: {
    fontWeight: '600',
  },
  ratingItem: {
    padding: '10px 0',
    width: 24,
    height: 24,
  },
};

const ProductMeta = ({ product }) => (
  <Fragment>
    <Row inner style={styles.label}>
      <h5 style={styles.bottomMargin}>Stats</h5>
    </Row>
    {(product?.isReviewable || product?.totalRatingEntries) && !product?.totalRatingEntries && (
      <Row inner style={styles.label}>
        This product hasn&apos;t been reviewed yet. Stay tuned!
      </Row>
    )}
    {(product?.isReviewable || product?.ratingAvg > 0) && product?.ratingAvg > 0 && (
      <Fragment>
        <Row inner style={styles.label}>
          Rating Average
        </Row>
        <Row inner style={styles.bottomMargin}>
          <Rating
            style={styles.ratingItem}
            onChange={noop}
            readOnly
            value={product?.ratingAvg}
          />
        </Row>
      </Fragment>
    )}
    {((product?.isReviewable || product?.reviewCount > 0)
      || (product?.isReviewable || product?.totalRatingEntries > 0)) && (
      <Fragment>
        <Row inner style={styles.label}>
          Reviews
        </Row>
        <Row inner style={styles.bottomMargin}>
          {approx(
            product?.reviewCount > 0
              ? product?.reviewCount
              : product?.totalRatingEntries,
          )}
        </Row>
      </Fragment>
    )}
    {!product?.isReviewable && product?.commentCount > 0 && (
      <Fragment>
        <Row inner style={styles.label}>
          Reviews
        </Row>
        <Row inner style={styles.bottomMargin}>
          {approx(product?.commentCount)}
        </Row>
      </Fragment>
    )}
  </Fragment>
);

ProductMeta.propTypes = {
  product: PropTypes.object.isRequired,
};

export default ProductMeta;
